import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import InlineSVG from 'svg-inline-react'
import { useSelector, useDispatch } from 'react-redux'
import * as Selectors from 'state/selectors'
import * as Actions from 'state/actions'

import iconReload from 'assets/icons/ico-reload.svg'
import NavHeader from "../../navbar/NavHeader"
import OrgMenu from "../../navbar/OrganisationsMenu"

const TopBarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
const TopBarTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #323751;
`
const RightPanel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`
const ReloadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 15px;
  
  user-select: none;
  cursor: pointer;
`
const Icon = styled(InlineSVG)`
  transform: scale(.68);
`
const ReloadTitle = styled.div``
const disabled = props => props.disabled && css`
  cursor: default;
  opacity: .7;
`
const SaveButton = styled.div`
  background-color: #6DB5BE;
  color: #ffffff;
  height: min-content;
  padding: 5px 16px;
  border-radius: 4px;
  
  user-select: none;
  cursor: pointer;
  transition: opacity .3s ease;
  
  ${disabled}
`

const TopBar = () => {
  const dispatch = useDispatch()
  const reload = () => dispatch(Actions.fetchSettingsInboxesOptions())

  const settingsInboxesState = useSelector(Selectors.getSettingsInboxesState)
  const isSaveButtonDisabled = settingsInboxesState.isRequesting || !settingsInboxesState.collection.length

  const saveInboxes = () => {
    if(isSaveButtonDisabled) return

    dispatch(Actions.saveSettingInboxes())
  }

  return (
    <TopBarWrapper>
      <TopBarTitle>
        Inboxes
      </TopBarTitle>

      <RightPanel>

        <ReloadWrapper onClick={reload}>
          <Icon src={iconReload} />

          <ReloadTitle>
            Reload projects
          </ReloadTitle>
        </ReloadWrapper>

        <SaveButton
          onClick={saveInboxes}
          disabled={isSaveButtonDisabled}
        >
          Save changes
        </SaveButton>
      </RightPanel>
    </TopBarWrapper>
  )
}

export default TopBar
